import { Just, Nothing } from 'purify-ts/Maybe';
export const buildStoreCache = () => {
    const globalCache = new Map();
    const queryCache = (storeId, cacheKey) => {
        const storeCache = globalCache.get(storeId);
        return (storeCache === undefined ? Nothing
            : storeCache.has(cacheKey) ? Just(storeCache.get(cacheKey))
                : Nothing);
    };
    const addValueToStoreCache = (storeId, key, value) => {
        var _a;
        const storeCache = (_a = globalCache.get(storeId)) !== null && _a !== void 0 ? _a : new Map();
        storeCache.set(key, value);
        globalCache.set(storeId, storeCache);
    };
    const deleteStoreCache = (storeId) => {
        globalCache.delete(storeId);
    };
    const deleteKeyFromStore = (storeId, key) => {
        const storeCache = globalCache.get(storeId);
        if (storeCache) {
            storeCache.delete(key);
        }
    };
    return {
        queryCache,
        addValueToStoreCache,
        deleteStoreCache,
        deleteKeyFromStore,
    };
};
